import "../../../../../src/App.css";
import axios from "axios";
import MiniDrawer from "../../../../components/MiniDrawer/MiniDrawer";
import StaffView from "../StaffListMain/StaffView/StaffView";
import StaffList from "../StaffListMain/StaffList/StaffList";
import React, { useState, useEffect } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Wrapper from "../../../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PaginationLink from "../../../../components/Pagination/Pagination";

function StaffListMain() {
  const [userDetailResponse, setUserDetailResponse] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);

  const [openStaffView, setOpenStaffView] = useState(false);
  const baseAPI = process.env.REACT_APP_API_URL;
  const heading = "Staff List";

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETEmployeeByDepartment?department_id=3`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {          
          setUserDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, [baseAPI]);

  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Staff List | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; List</span>
                </h1>
              </div>
              <div style={{ width: "8rem" }}>
                <select className="form-control" name="country">
                  <option value="0">INDIA </option>
                  <option value="1">DUBAI </option>
                </select>
              </div>
            </div>
            <div>
              <Wrapper className="ViewLeadDetails">
                {/* --------------master top button---------start---------- */}
                <div className="container-fluid" styel={{ marginTop: "3rem" }}>
                  <div className="headerButton">
                    <div>
                      <button style={{ height: "53px", width: "101px" }}>
                        <FilterAltOutlinedIcon className="icon" />
                        Filters
                      </button>
                    </div>
                    <div className="button-container">
                      <button>
                        <DownloadIcon className="icon" />
                        Download Excel
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div>
                    <span style={{ fontSize: "25px" }}>{heading}</span>
                  </div>
                </div>
                {/* --------------master top button---------end---------- */}
                {openStaffView && <StaffView selectedUser={selectedUser} />}
                <StaffList
                  userDetailResponse={userDetailResponse}
                  setOpenStaffView={setOpenStaffView}
                  openStaffView={openStaffView}
                  setSelectedUser={setSelectedUser}
                />
                <PaginationLink />
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffListMain;
